import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";

const ReverseRow = ({ parent, title, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    if (!node) return null;

    const style = getStyle(node, undefined, stateMode, cvModeIndex);
    const stylePath = getStylePath(undefined, stateMode, cvModeIndex);

    //Flex direction
    const flexDirection = style.stateStyle?.flexDirection || style.default?.flexDirection || "column";

    const reverseRowCallback = (value: boolean) => {
        dispatch(
            updateNodeProperty({
                propertyPath: [...stylePath, "flexDirection"],
                value: value ? "row-reverse" : "row"
            })
        );
    };

    if (!["row", "row-reverse"].includes(flexDirection)) {
        return null;
    }

    return (
        <SidebarCollapse title={title || "Reverse row"} parent={parent}>
            <Toggle label="Reverse row?" checked={flexDirection === "row-reverse"} callback={reverseRowCallback} />
        </SidebarCollapse>
    );
};

export default ReverseRow;
